<h2 mat-dialog-title>Edit File Authorization</h2>

<mat-dialog-content>
  <div class="dialog-content">
    <div *ngIf="dialogError" class="api-error-banner" style="margin-bottom: 4px;">{{ dialogError }}</div>
    <div *ngIf="validationError" class="api-error-banner" style="margin-bottom: 4px;">{{ validationError }}</div>
    <div class="info-section">
      <div class="info-row">
        <span class="label">Authorization Number:</span>
        <span class="value">{{ data.fileAuthorization.AuthorizationNumber }}</span>
      </div>
      <div class="info-row">
        <span class="label">FTP Directory:</span>
        <span class="value">{{ data.fileAuthorization.FTPDirectoryName }}</span>
      </div>
      <div class="info-row">
        <span class="label">Last Updated Date:</span>
        <span class="value">{{ data.fileAuthorization.LastUpdated ? (data.fileAuthorization.LastUpdated | date: 'medium') : '-' }}</span>
      </div>
      <div class="info-row">
        <span class="label">Last Updated By:</span>
        <span class="value">{{ data.fileAuthorization.LastUpdatedBy || '-' }}</span>
      </div>
    </div>

    <div class="edit-section">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Load Tolerance Days</mat-label>
        <input
          matInput
          type="text"
          inputmode="numeric"
          [(ngModel)]="loadToleranceDaysStr"
          (input)="onToleranceInput($event)"
          placeholder="Enter days"
          name="loadToleranceDays"
        />
        <mat-hint>Number of days tolerance for file loading</mat-hint>
      </mat-form-field>

      <div class="checkbox-field">
        <mat-checkbox [(ngModel)]="autoProcessFiles" color="primary">
          Auto Process Files
        </mat-checkbox>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Comment</mat-label>
        <textarea
          matInput
          [(ngModel)]="comment"
          placeholder="Add or edit comment..."
          name="comment"
          rows="1"
        ></textarea>
        <mat-hint>Optional comment or notes about this authorization</mat-hint>
      </mat-form-field>
    </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="onSave()">Save</button>
  <button mat-stroked-button (click)="onCancel()">Cancel</button>
</mat-dialog-actions>
